import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/FormBuilder/shared/InternalContentBadge.tsx
var InternalContentBadge = () => {
	return /* @__PURE__ */ jsx("small", {
		className: "text-color-light mx-xs bg-caution-faded rounded px-1 text-sm font-light",
		children: "Internal"
	});
};
//#endregion
export { InternalContentBadge };

//# sourceMappingURL=InternalContentBadge.js.map